export const UserIcon = ({color, width, height}: {color: string, width: number, height: number}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width= {width}
    height= {height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"

    style={{
      color: color,
      display: "block",
    }}
  >
    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);
